import React from 'react';
import { Table, Popconfirm, Flex, Button, Typography } from 'antd';

import { TableCol } from './getTableCol';

import { planStruct } from './struct';
import { getRandomId } from '../../../../../../utilities/randomId';
import { getAsNumber } from '../../../../../../utilities/numberConvertion';
import { useSelector } from 'react-redux';

const { Title } = Typography

export const Plan = ({ planing, handlePlaning, status }) => {
  const _static = useSelector((state) => state.static);
  const { staticData } = _static;
  const { evaluation_status: evaluationStatus } = staticData;

  const handleAdd = () => {
    const newPlaning = {
      key: getRandomId(),
      detail: '',
      number_of_ra: 0
    };
    handlePlaning([...planing, newPlaning]);
  };

  const handleSave = (row) => {
    const currentOutcome = [...planing];
    const index = currentOutcome.findIndex((item) => row.key === item.key);
    const item = currentOutcome[index];

    row.number_of_ra = getAsNumber(row.number_of_ra);

    currentOutcome.splice(index, 1, {
      ...item,
      ...row
    });
    handlePlaning(currentOutcome);
  };

  const handleDelete = (key) => {
    const newData = planing.filter((item) => item.key !== key);
    handlePlaning(newData);
  };

  const columns = [
    ...TableCol(handleSave, status),
    {
      title: 'Action',
      dataIndex: 'operation',
      render: (_, record) => (
        <Popconfirm
          title="Sure to delete?"
          onConfirm={() => handleDelete(record.key)}
          disabled={status === 1 || status === 2 || status === 3}
        >
          <a>Delete</a>
        </Popconfirm>
      )
    }
  ];

  return (
    <>
      <Flex justify='flex-end'>
        {
          evaluationStatus?.filter((e) => e.value === status)?.length > 0 &&
          <Title level={5}>
            Status~
            {evaluationStatus?.filter((e) => e.value === status)?.[0]?.label}
          </Title>
        }
      </Flex>

      <Table {...planStruct.table} columns={columns} dataSource={planing} />
      <br />

      <Flex {...planStruct.actionSection}>
        <Button className="glow-btn" disabled={status === 1 || status === 2 || status === 3} onClick={handleAdd}>Add New Item</Button>{' '}
      </Flex>

      <Typography.Text type="secondary" style={{ display: 'block', marginTop: 8, fontSize: 12, color: '#e92a2a' }}>
        *Without attachment APA score will be invalid.
      </Typography.Text>
    </>
  );
};
